import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // VITAL: instrui o browser a incluir o cookie httpOnly em todas as requisições
  // cross-origin para a API. Sem isso, o cookie jwt não é enviado.
  withCredentials: true,
});

// Interceptor de REQUEST:
// O token não é mais lido do localStorage — o cookie httpOnly é anexado
// automaticamente pelo browser em todas as requisições (graças ao withCredentials).
// Este interceptor não precisa mais fazer nada com o token.
api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// Interceptor de RESPONSE:
// Se a API retornar 401, limpa os dados públicos do usuário e redireciona para login.
// O cookie httpOnly é gerenciado pelo backend (endpoint /auth/2fa/logout).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Limpa apenas os dados de UI (nome, papel) — token nunca ficou no localStorage
      sessionStorage.removeItem('usuario');
      window.dispatchEvent(new Event('auth:logout'));
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
